import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../style/setup.css"

const ActiveSessionRedirect = ({ children }) => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  
  if (isLoading) {
    return (
      <div className="fullscreen-loading">
        <div className="spinner"></div>
      </div>
    )
  }

  if(user){
    navigate("/dashboard");
  }
  
  return children;
};

export default ActiveSessionRedirect;
